export enum eAppState {
  INITIALIZING_OPTIMIZATION,
  LOADING_PROJECT,
  DOWNLOADING_PROJECT,
  NONE,
}
